/* unplugin-vue-components disabled */import script from "./ProductDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductDetails.vue?vue&type=script&lang=ts&setup=true"

import "./ProductDetails.vue?vue&type=style&index=0&id=04a1c264&lang=less&scoped=true"

import exportComponent from "/data/liulv-h5/quantum-technology/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04a1c264"]])

export default __exports__